import $ from 'jquery';
//replace fixed aspect ratio picture elements with divs that use background image as fallback (ie11)
//requires accompanying css (see .bg-image-fallback and picture.fixed-aspect)
//example markup:
//<picture class="fixed-aspect">
//  <source media="(max-width: 799px)" srcset="https://path/to/your/image.jpg?size=small"/>
//  <source media="(min-width: 800px) and (max-width: 1200px)" srcset="https://path/to/your/image.jpg?size=medium"/>
//  <source media="(min-width: 1201px)" srcset="https://path/to/your/image.jpg?size=large"/>
//  <img data-focus-top="40" data-focus-left="65.5" style="object-position:65.5% 40%" src="https://path/to/your/image.jpg"/>
//</picture>
function objectFitPolyfill() {
  let supportsObjectFit = 'objectFit' in document.documentElement.style,
    bgPolyString = '<div class="bg-image-fallback"></div>',
    pictures = document.querySelectorAll('picture.fixed-aspect'),
    objectFitPoly = function () {
      Array.prototype.slice.apply(pictures).forEach(function (picture) {
        var $img = $(picture).find('img'),
          src = $img.attr('src'),
          pos = $img.data('focus-left') > 0 && $img.data('focus-top') > 0 ? $img.data('focus-left') + '% ' + $img.data('focus-top') + '%' : '50% 50%',
          paddingBottom = $(picture).css('padding-bottom'),
          polyEle = $(bgPolyString, {}).css({
            'background-image': 'url('.concat(src, ')'),
            'background-position': pos,
          });
        $(picture).append(polyEle);
        $img.hide();
      });
    }; //objectfitpoly

  if (!supportsObjectFit) {
    objectFitPoly();
  }
}

export default objectFitPolyfill;
